// extracted by mini-css-extract-plugin
export default {"colorPink":"#ff6392","colorYellow":"#ffbf5f","colorAquamarine":"#4effbf","colorNavyblue":"#618dff"};